import api from '@/api_alv'
import Vue from 'vue'
import i18n from '@/assets/i18n/i18n'
import { router } from '@/router.js'

const DIR = 'erp/shipping'
const DEFAULT_SHIPPING = {
    "id": 0,
    "alvId": "ALV000000000SD",
    "date": new Date().toISOString().slice(0, 10),
    "language": null,
    "noteForRecipient": null,
    "number": null,
    "recipient": null,
    "recipientFullAddress": null,
    "recipientFullShippingAddress": null,
    "recipientVatId": null,
    "recipientTransactionNumber": null,
    "rows": [],
    "sender": null,
    "senderName": null,
    "senderFullAddress": null,
    "status": "draft",
    "title": null,
    "type": "picking",
    "vatId": null,
    "linkedShipping": null
}

const DEFAULT_SHIPPINGROWS = {
    "id": 0,
    "alvId": "ALV000000000SR",
    "batch": null,
    "connectionId": null,
    "connectionObject": null,
    "price": null,
    "productId": null,
    "quantity": null,
    "title": null,
    "type": null,
}

const state = {
    shipping: [],
    selectedShipping: [],
    isAllSelectedShipping: false,
    shippingTitle: null,

    // Filter
    shippingSearch: '',
    selectedShippingPeriodFromFilter: null,
    selectedShippingPeriodToFilter: null,
    selectedShippingTypeFilter: [],
    selectedShippingStatusFilter: [],

    //Sorting
    shippingServerSideSortingOptions: {
        sortBy: ['date'],
        sortDesc: [true],
        mustSort: true
    },

    // Actions
    selectedShippingAction: [],

    // Details
    defaultNewShipping: DEFAULT_SHIPPING,
    shippingUniqueId: '',
    expandedShipping: [],
    shippingDetails: DEFAULT_SHIPPING,
    shippingSenderOptions: [],
    shippingRecipientOptions: [],

    // Edit Form
    selectedShippingId: null,

    // Panel: Shipping Rows
    shippingShippingRows: [],
    selectedShippingShippingRows: [],
    showShippingInventoriesPreview: false,
    invokeSaveCallForShippingInventories:false,
    disableShowInventoriesButton:false,

    // Editing Dialog: shippingShippingRows
    defaultShippingShippingRows: DEFAULT_SHIPPINGROWS,
    shippingShippingRowsEditingDialogDetails: DEFAULT_SHIPPINGROWS,
    shippingShippingRowsTitleOptions: [],
    shippingShippingRowsTitleSearch: null,
    shippingShippingRowsIsNewSearch: null,

    // Pro Forma Dialog
    showProFormaDialog : false,
    proFormaDialogDetailsAmountToSplit:"",
    proFormaDialogDetailsProFormaText:"",

}

const getters = {
    // Shipping List Page
    getShipping                     (state) { return state.shipping },
    getSelectedShipping             (state) { return state.selectedShipping },
    getIsAllSelectedShipping        (state) { return state.isAllSelectedShipping },
    getShippingTitle                (state) { return state.shippingTitle },
    
    // Filters & Actions & Buttons
    getShippingSearch                  (state) { return state.shippingSearch },
    getSelectedShippingPeriodFromFilter(state) { return state.selectedShippingPeriodFromFilter },
    getSelectedShippingPeriodToFilter  (state) { return state.selectedShippingPeriodToFilter },
    getSelectedShippingAction          (state) { return state.selectedShippingAction },
    getSelectedShippingTypeFilter      (state) { return state.selectedShippingTypeFilter },
    getSelectedShippingStatusFilter    (state) { return state.selectedShippingStatusFilter },

    //Sorting
    getShippingServerSideSortingOptions (state) {return state.shippingServerSideSortingOptions},

    // Details
    getDefaultNewShipping               (state) { return state.defaultNewShipping },
    getShippingUniqueId                 (state) { return state.shippingUniqueId }, 
    getExpandedShipping                 (state) { return state.expandedShipping },
    getShippingDetails                  (state) { return state.shippingDetails },
    getShippingDetailsLinkedInvoice     (state) { return state.shippingDetails.linkedInvoice },
    getShippingDetailsAlvId             (state) { return state.shippingDetails.alvId },
    getShippingDetailsDate              (state) { return state.shippingDetails.date },
    getShippingDetailsLanguage          (state) { return state.shippingDetails.language },
    getShippingDetailsNoteForRecipient  (state) { return state.shippingDetails.noteForRecipient },
    getShippingDetailsNumber            (state) { return state.shippingDetails.number },
    getShippingDetailsRecipient         (state) { return state.shippingDetails.recipient },
    getShippingDetailsRecipientVatId    (state) { return state.shippingDetails.recipientVatId },
    getShippingDetailsRecipientTransactionNumber    (state) { return state.shippingDetails.recipientTransactionNumber },
    getShippingDetailsSender            (state) { return state.shippingDetails.sender },
    getShippingDetailsStatus            (state) { return state.shippingDetails.status },
    getShippingDetailsType              (state) { return state.shippingDetails.type },
    getShippingDetailsVatId             (state) { return state.shippingDetails.vatId },
    
    getShippingDetailsSenderName                    (state) { return state.shippingDetails.senderName },
    getShippingDetailsSenderFullAddress             (state) { return state.shippingDetails.senderFullAddress },
    getShippingDetailsRecipientFullAddress          (state) { return state.shippingDetails.recipientFullAddress },
    getShippingDetailsRecipientFullShippingAddress  (state) { return state.shippingDetails.recipientFullShippingAddress },
    getShippingDetailsLinkedShipping                (state) { return state.shippingDetails.linkedShipping },

    getShippingSenderOptions            (state) { return state.shippingSenderOptions },
    getShippingRecipientOptions         (state) { return state.shippingRecipientOptions },

    // Panel: Shipping Rows
    getShippingShippingRows                         (state) { return state.shippingShippingRows },
    getSelectedShippingShippingRows                 (state) { return state.selectedShippingShippingRows },
    getShowShippingInventoriesPreview               (state) { return state.showShippingInventoriesPreview },
    getInvokeSaveCallForShippingInventories         (state) { return state.invokeSaveCallForShippingInventories },
    getDisableShowInventoriesButton                 (state) { return state.disableShowInventoriesButton },



    // Editing Dialog: shippingShippingRows
    getDefaultShippingShippingRows                  (state) { return state.defaultShippingShippingRows },
    getShippingShippingRowsEditingDialogDetails     (state) { return state.shippingShippingRowsEditingDialogDetails },
    
    getShippingShippingRowsDetailsAlvId             (state) { return state.shippingShippingRowsEditingDialogDetails.alvId },
    getShippingShippingRowsDetailsBatch             (state) { return state.shippingShippingRowsEditingDialogDetails.batch },
    getShippingShippingRowsDetailsConnectionId      (state) { return state.shippingShippingRowsEditingDialogDetails.connectionId },
    getShippingShippingRowsDetailsPrice             (state) { return state.shippingShippingRowsEditingDialogDetails.price },
    getShippingShippingRowsDetailsProductId         (state) { return state.shippingShippingRowsEditingDialogDetails.productId },
    getShippingShippingRowsDetailsQuantity          (state) { return state.shippingShippingRowsEditingDialogDetails.quantity },
    getShippingShippingRowsDetailsTitle             (state) { return state.shippingShippingRowsEditingDialogDetails.title },
    // type is an additional attribute to store the searchType for each row, especially new rows
    getShippingShippingRowsDetailsType              (state) { return state.shippingShippingRowsEditingDialogDetails.type },

    getShippingShippingRowsTitleOptions             (state) { return state.shippingShippingRowsTitleOptions },
    getShippingShippingRowsTitleSearch              (state) { return state.shippingShippingRowsTitleSearch },
    getShippingShippingRowsIsNewSearch              (state) { return state.shippingShippingRowsIsNewSearch },

   // Pro Forma Dialog: amountToSplit
   getShowProFormaDialog                            (state) { return state.showProFormaDialog },
   getProFormaDialogDetailsAmountToSplit            (state) { return state.proFormaDialogDetailsAmountToSplit },
   getProFormaDialogDetailsProFormaText             (state) { return state.proFormaDialogDetailsProFormaText },



}

const mutations = {
    // Shipping List Page    
    setShipping:                        (state, item)   => { state.shipping = item },
    setSelectedShipping:                (state, item)   => { state.selectedShipping = item },
    setIsAllSelectedShipping:           (state, item)   => { state.isAllSelectedShipping = item },
    setShippingTitle:                   (state, item)   => { state.shippingTitle = item },

    // Filters & Actions & Buttons
    setShippingSearch:                   (state, item)      => { state.shippingSearch = item },
    setSelectedShippingPeriodFromFilter: (state, selected)  => { state.selectedShippingPeriodFromFilter = selected },
    setSelectedShippingPeriodToFilter:   (state, selected)  => { state.selectedShippingPeriodToFilter = selected },
    setSelectedShippingAction:           (state, action)    => { state.selectedShippingAction = action }, 
    setSelectedShippingTypeFilter:       (state, value)     => { state.selectedShippingTypeFilter = value },
    setSelectedShippingStatusFilter:     (state, value)     => { state.selectedShippingStatusFilter = value },
    
    //Sorting
    setShippingServerSideSortingOptions: (state, value) => { state.shippingServerSideSortingOptions = value},

    // Details
    setDefaultNewShipping:              (state)         => { state.defaultNewShipping = DEFAULT_SHIPPING },
    setShippingUniqueId:                (state, id)     => { state.shippingUniqueId = id },
    setExpandedShipping:                (state, item)   => { 
                                                                if (Object.keys(item).length === 0) state.expandedShipping = []
                                                                else state.expandedShipping.push(item) 
                                                            },
    setShippingSenderOptions:           (state, items)  => { state.shippingSenderOptions = items },
    setShippingRecipientOptions:        (state, items)  => { state.shippingRecipientOptions = items },
    setShippingDetails:                 (state, details)=> { state.shippingDetails = details },
    setShippingDetailsAlvId:            (state, alvId)  => { state.shippingDetails.alvId = alvId },
    setShippingDetailsDate:             (state, date)   => { state.shippingDetails.date = date },
    setShippingDetailsLanguage:         (state, lang)   => { state.shippingDetails.language = lang},
    setShippingDetailsNoteForRecipient: (state, note)   => { state.shippingDetails.noteForRecipient = note},
    setShippingDetailsNumber:           (state, num)    => { state.shippingDetails.number = num},
    setShippingDetailsRecipient:        (state, item)   => { state.shippingDetails.recipient = item },
    setShippingDetailsRecipientVatId:   (state, item)   => { state.shippingDetails.recipientVatId = item },
    setShippingDetailsRecipientTransactionNumber:   (state, item)   => { state.shippingDetails.recipientTransactionNumber = item },
    setShippingDetailsSender:           (state, item)   => { state.shippingDetails.sender = item },
    setShippingDetailsStatus:           (state, item)   => { state.shippingDetails.status = item },
    setShippingDetailsType:             (state, item)   => { state.shippingDetails.type = item },
    setShippingDetailsVatId:            (state, item)   => { state.shippingDetails.vatId = item },
    
    setShippingDetailsSenderName:                   (state, item) => { state.shippingDetails.senderName = item },
    setShippingDetailsSenderFullAddress:            (state, address) => { state.shippingDetails.senderFullAddress = address },
    setShippingDetailsRecipientFullAddress:         (state, address) => { state.shippingDetails.recipientFullAddress = address },
    setShippingDetailsRecipientFullShippingAddress: (state, address) => { state.shippingDetails.recipientFullShippingAddress = address },

    // Panels
    setShippingShippingRows:                     (state, rows)      => { state.shippingShippingRows = rows },
    setSelectedShippingShippingRows:             (state, rows)      => { state.selectedShippingShippingRows = rows },
    setShowShippingInventoriesPreview:           (state, show)      => { state.showShippingInventoriesPreview = show },
    setInvokeSaveCallForShippingInventories:     (state, value)      => { state.invokeSaveCallForShippingInventories = value },
    setDisableShowInventoriesButton:             (state, value)      => { state.disableShowInventoriesButton = value },

    // Editing Dialog: shippingShippingRows
    setDefaultShippingShippingRows:              (state)            => { state.defaultShippingShippingRows = DEFAULT_SHIPPINGROWS },
    setShippingShippingRowsEditingDialogDetails: (state, details)   => { state.shippingShippingRowsEditingDialogDetails = details },

    setShippingShippingRowsDetailsAlvId:         (state, alvId)     => { state.shippingShippingRowsEditingDialogDetails.alvId = alvId },
    setShippingShippingRowsDetailsBatch:         (state, batch)     => { state.shippingShippingRowsEditingDialogDetails.batch = batch },
    setShippingShippingRowsDetailsConnectionId:  (state, id)        => { state.shippingShippingRowsEditingDialogDetails.connectionId = id },
    setShippingShippingRowsDetailsPrice:         (state, price)     => { state.shippingShippingRowsEditingDialogDetails.price = price },
    setShippingShippingRowsDetailsProductId:     (state, id)        => { state.shippingShippingRowsEditingDialogDetails.productId = id },
    setShippingShippingRowsDetailsQuantity:      (state, quantity)  => { state.shippingShippingRowsEditingDialogDetails.quantity = quantity },
    setShippingShippingRowsDetailsTitle:            (state, title)     => { state.shippingShippingRowsEditingDialogDetails.title = title },

    // type is an additional attribute to store the searchType of a new row
    setShippingShippingRowsDetailsType:             (state, type)      => { state.shippingShippingRowsEditingDialogDetails.type = type },
      
    setShippingShippingRowsTitleOptions:            (state, options)    => { state.shippingShippingRowsTitleOptions = options },
    setShippingShippingRowsTitleSearch:             (state, search)     => { state.shippingShippingRowsTitleSearch = search },
    setShippingShippingRowsIsNewSearch:             (state, flag)       => { state.shippingShippingRowsIsNewSearch = flag },

    // Pro Forma Dialog 
    setShowProFormaDialog:                          (state, value)      => { state.showProFormaDialog = value },
    setProFormaDialogDetailsAmountToSplit:          (state, value)      => { state.proFormaDialogDetailsAmountToSplit = value },
    setProFormaDialogDetailsProFormaText:           (state, value)      => { state.proFormaDialogDetailsProFormaText = value },
     
}

const actions = {
    async fetchShipping({ commit, getters }) {

        commit('setIsLoading', true)
        // check for set filters
        let filterObj = {
            'search' :       getters.getShippingSearch,
            'type':          getters.getSelectedShippingTypeFilter,
            'status':        getters.getSelectedShippingStatusFilter,
            'periodFrom' :   getters.getSelectedShippingPeriodFromFilter,
            'periodTo':      getters.getSelectedShippingPeriodToFilter
        }
        // sorting options
        let options = getters.getShippingServerSideSortingOptions;

        // create string of filter params for api call
        let paramsString = this._vm.$alvPlugin.createApiUrlFilterString(filterObj)

        // Get list items from db
        let response = await api.getListData2(DIR, getters.getCurrentPage, options.sortBy, options.sortDesc, paramsString)   
        
        if(response === undefined || response.list.length === 0 || response.error === 1) { 
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            commit('setShipping', [])   
        } else {
            commit('setShipping', response.list)   
        }

        this._vm.$alvPlugin.storePagingInformations(response.filteredRecords, response.currentPage, response.totalRecords)
        commit('setIsLoading', false)

    },

    // RULES for AZ SEARCHES in Sender/Recipient depending on TYPE (no freetext, always from A-Z)
    //
    // Eingangsschein (incoming): 
    // Absender = Autocomplete | any AZ
    // Empfänger = Dropdown | type="warehouse" and type="warehouseOwn"
    
    // Lieferschein (shipping):
    // Absender = Dropdown | type="warehouseOwn"
    // Empfänger = Autocomplete | any AZ
    
    // Pickschein (picking):
    // Absender = Dropdown | type="warehouse" (NOT "warehouseOwn")
    // Empfänger = Autocomplete | any AZ
    
    // Retourenschein (returning):
    // Absender = Autocomplete | any AZ
    // Empfänger = Dropdown | type="warehouse" and type="warehouseOwn"

    // SHIPPING SENDER (autocomplete)
    async fetchAutocompleteShippingSender({ commit }, searchTerm) {
        let response = await api.getAutocompleteSearch('az/persons', searchTerm)
        commit('setShippingSenderOptions', response.list)
    },

    // SHIPPING RECIPIENT (autocomplete)
    async fetchAutocompleteShippingRecipient({ commit }, input) {
        let response = await api.getAutocompleteSearch('az/persons', input)
        commit('setShippingRecipientOptions', response.list)
    },

    // SHIPPING SENDER (dropdown)
    async fetchDropdownShippingSender({ commit }, type) {
        let response = await api.getAzByType(type)
        commit('setShippingSenderOptions', response.list)
    },

    // SHIPPING SENDER (dropdown)
    async fetchDropdownShippingRecipient({ commit }, azTypes) {
        let totalList = []
        for(let type of azTypes) {
            let response = await api.getAzByType(type)
            totalList = totalList.concat(response.list);
        }
        commit('setShippingRecipientOptions', totalList)
    },
    
    async fillDropdownFromAz({ commit, dispatch }, type) {
        commit('setShippingDetailsSender', null)
        commit('setShippingDetailsSenderFullAddress', null)
        commit('setShippingSenderOptions', [])
        commit('setShippingDetailsRecipient', null)
        commit('setShippingDetailsRecipientFullAddress', null)
        commit('setShippingDetailsRecipientFullShippingAddress', null),
        commit('setShippingRecipientOptions', [])
        switch (type) {
            case "incoming":
                dispatch('fetchDropdownShippingRecipient', ['warehouseOwn', 'warehouse'] )
                break;
            case "shipping":
                dispatch('fetchDropdownShippingSender', 'warehouseOwn' )
                break;
            case "picking":
                dispatch('fetchDropdownShippingSender', 'warehouse' )
                break;
            case "returning":
                dispatch('fetchDropdownShippingRecipient', ['warehouseOwn', 'warehouse'] )
                break;
            default:
                break;
        }
    },

    // Fetch Details for a specific Shipping document     
    async fetchShippingDetails({ commit, getters, dispatch }, alvId) {
        if(alvId === undefined) alvId = getters.getShippingDetailsAlvId
        let values = {}
        let currentPage = router.currentRoute.name
        // console.log(router.currentRoute.name)
        if(alvId === 'new') {
            // NEW shipping document
            values = JSON.parse(JSON.stringify(getters.getDefaultNewShipping))
            // make sure that correct dropdown values are in address selectors, e.g. default for "shipping"
            dispatch('fillDropdownFromAz', values.type)
        }
        else {
            // EDIT existing shipping document (but also for READONLY)
            let response = await api.getDetailsById(DIR, alvId, (getters.getInvokeSaveCallForShippingInventories ? '?action=showInventories' : ''))

            if(response === null || response.error === 1) {
                    values = getters.getDefaultNewShipping
            } else {
                if(response === undefined || response.length === 0 || response.error === 1) {
                    values = {}
                } else {
                    
                    // EDIT and READONLY
                    // Three cases:
                    // 1) recipientFullAddress is not null -> then to show that
                    // 2) recipientFullAddress is null -> check if recipient object exists
                    // 3) recipient.fullAddress is not null -> then to show that
                    //
                    // if showing in EDIT mode -> replace <br/> with \n for editable textarea
                    // if showing in READONLY mode -> show as it comes back from the BE with <br/> for HTML output

                    let recipientAddress = ""
                    if (response.recipientFullAddress != null)
                        recipientAddress = response.recipientFullAddress
                    else if (response.recipient.fullAddress != null)
                        recipientAddress = response.recipient.fullAddress

                    let recipientShippingAddress = ""
                    if (response.recipientFullShippingAddress != null)
                        recipientShippingAddress = response.recipientFullShippingAddress
                    else if (response.recipient.fullShippingAddress != null)
                        recipientShippingAddress = response.recipient.fullShippingAddress

                    let senderAddress = ""
                    if (response.senderFullAddress != null)
                        senderAddress = response.senderFullAddress
                    else if (response.sender.fullAddress != null)
                        senderAddress = response.sender.fullAddress

                    if (currentPage == "ShippingEdit") {
                        senderAddress = senderAddress.replace(/<br\s*[\/]?>/gi, "\n")
                        recipientAddress = recipientAddress.replace(/<br\s*[\/]?>/gi, "\n")
                        recipientShippingAddress = recipientShippingAddress.replace(/<br\s*[\/]?>/gi, "\n")
                        // make sure that correct dropdown values are in address selectors, dependent on "type"
                        dispatch('fillDropdownFromAz', response.type)
                    }

                    if(currentPage === 'Shipping') {
                        if(response.noteForRecipient !== null) {
                            response.noteForRecipient = response.noteForRecipient.replaceAll("\n", "<br />")
                        }
                    }
                    response.senderFullAddress = senderAddress
                    response.recipientFullAddress = recipientAddress
                    response.recipientFullShippingAddress = recipientShippingAddress

                    values = response
                }
            }
        }
        
        commit('setShippingDetails', values)
        dispatch('fetchShippingShippingRows')

        // for EXISTING (Readonly and Edit) shipping documents: set recipient as option in autocomplete (?)... taken from invoices
        if (getters.getShippingDetailsRecipient !== undefined && getters.getShippingDetailsRecipient !== null) {
            // for Sender
            commit('setShippingSenderOptions', [getters.getShippingDetailsSender])
            commit('setShippingDetailsSender', getters.getShippingDetailsSender)
            commit('setShippingDetailsSenderName', getters.getShippingDetailsSenderName)
            // if (currentPage != "ShippingEdit")
            //     commit('setShippingDetailsSenderFullAddress', getters.getShippingDetailsSender.fullAddress)
            // for Recipient
            commit('setShippingRecipientOptions', [getters.getShippingDetailsRecipient])
            // if (currentPage != "ShippingEdit") {
            //     commit('setShippingDetailsRecipientFullAddress', getters.getShippingDetailsRecipient.fullAddress)
            //     commit('setShippingDetailsRecipientFullShippingAddress', getters.getShippingDetailsRecipient.fullShippingAddress)
            // }
        }

        commit('setIsLoading', false)
    },
    
    // SAVE
    async saveShippingForm({ commit, getters, dispatch }) {
        let alvId = getters.getShippingDetailsAlvId
        let metaData = getters.getShippingDetails
        let isNew = router.currentRoute.params.alvId === "new"

        let response = await api.saveEditForm(DIR, alvId, metaData, isNew)

        if(response === undefined || response.length === 0 || response.error === 1) { 
            response = []
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_SAVING_NOT_SUCCESSFUL'), // TODO: better message for user
            })
        } else {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_SAVING_SUCCESSFUL')
            })
            // redirect for url now with ALVID
            if(isNew) {
                router.push( { name: 'ShippingEdit', params: { alvId:  response.response.alvId } })
            }
            // refresh data
            await dispatch('fetchShippingDetails',  response.response.alvId)
        }
    }, 

    // ACTIONS
    async doShippingAction({ commit, dispatch, getters }) {
        switch(state.selectedShippingAction) {
            case 'print': 
                if(state.selectedShipping.length > 0) {
                    dispatch('printShipping')
                } else {
                    commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE') 
                    commit('setShowSelectionRequiredDialog', true)
                }
                break
            case 'createFromShipping':
                if(state.selectedShipping.length === 1) {  
                    let selectedShipping = getters.getSelectedShipping  
                    let shippingList = getters.getShipping                        
                    let shippingData = shippingList.find(shipping => {
                        return shipping.alvId === selectedShipping[0]
                    })      
                    if(shippingData.status === "draft"){
                        commit('setSnackbar', {
                            type: 'error',
                            msg: i18n.t('lang_ERP_SHIPPING_SNACKBAR_PLEASE_CHANGE_STATUS_TO_RECORDED')
                        })
                    }else{
                        dispatch('createFromShipping')
                    } 
                } else {
                    commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_ONLY_ONE') 
                    commit('setShowSelectionRequiredDialog', true)
                }
                break
            case 'createProForma':
                if(state.selectedShipping.length === 1) {  
                    commit('setShowProFormaDialog', true)
                    break
                } else {
                    commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_ONLY_ONE') 
                    commit('setShowSelectionRequiredDialog', true)
                }
                break
            case 'createCreditNotesFromShipping':                
                if(state.selectedShipping.length === 1) {
                    let selectedShipping = getters.getSelectedShipping
                    let shippingList = getters.getShipping                        
                    let shippingData = shippingList.find(shipping => {
                        return shipping.alvId === selectedShipping[0]
                    })
        
                    if(shippingData.type === 'returning') {
                        if(shippingData.linkedShipping !== null) {
                            commit('setSnackbar', {
                                type: 'error',
                                msg: i18n.t('lang_ERP_SHIPPING_SNACKBAR_PLEASE_SELECT_RETURNS_NOTE_WITHOUT_CONNECTED_DOCUMENTS')
                            })
                        } else {
                            let selectedShipping = getters.getSelectedShipping  
                            let shippingList = getters.getShipping                        
                            let shippingData = shippingList.find(shipping => {
                                return shipping.alvId === selectedShipping[0]
                            })      
                            if(shippingData.status === "draft"){
                                commit('setSnackbar', {
                                    type: 'error',
                                    msg: i18n.t('lang_ERP_SHIPPING_SNACKBAR_PLEASE_CHANGE_STATUS_TO_RECORDED')
                                })
                            }else{
                                dispatch('createFromShipping')
                            } 
                        }                        
                    } else {
                        commit('setSnackbar', {
                            type: 'error',
                            msg: i18n.t('lang_ERP_SHIPPING_SNACKBAR_PLEASE_SELECT_RETURNS_NOTE')
                        })
                    }
                } else {
                    commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_ONLY_ONE') 
                    commit('setShowSelectionRequiredDialog', true)
                }
                break
            case 'createReturnsFromShipping': 
                if(state.selectedShipping.length === 1) {
                    dispatch('createReturnsFromShipping')
                } else {
                    commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_ONLY_ONE') 
                    commit('setShowSelectionRequiredDialog', true)
                }
                break
            case 'delete':
                if(state.selectedShipping.length > 0) {
                    commit('setShowDeletionDialog', true)
                } else {
                    commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE') 
                    commit('setShowSelectionRequiredDialog', true)	
                }
                break
            case 'export':
                if(state.selectedShipping.length === 1) {
                    dispatch('exportShipping')
                } else {
                    commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_ONLY_ONE') 
                    commit('setShowSelectionRequiredDialog', true)
                }
                break
            }
            
    },

    // DELETE
    async deleteSelectedShipping({ commit, getters, dispatch }) {  
        const response = await api.deleteEntries(DIR, getters.getSelectedShipping)

        if(response.error === -1) {        
            for(let i = 0; i < getters.getSelectedShipping.length; i++) {
                let index = getters.getShipping.findIndex(shipping => shipping.alvId == getters.getSelectedShipping[i])
                Vue.delete(getters.getShipping, index)
            }
            commit('setSelectedShipping', [])
            commit('setSelectedShippingAction', [])
            dispatch('fetchShipping')
        }
    },

    // FETCH SHIPPING ROWS
    async fetchShippingShippingRows({ commit, getters }){
        let shippingShippingRowsFromDB = await getters.getShippingDetails.rows
        if(shippingShippingRowsFromDB === undefined) return null
        else {
            commit('setIsLoading', false)
            if(shippingShippingRowsFromDB.length === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            commit('setShippingShippingRows', shippingShippingRowsFromDB)
        }
    },

    // FETCH PRODUCT TITLES
    async fetchAutocompleteShippingShippingRowsTitle({ commit, getters }, input) {
        // depends on type of Company and of selected Entry Type
        // Label Companies: label/releases
        // Publishing Companies: publishing/releases
        let searchContext = getters.getShippingShippingRowsTitleSearch
        let response = await api.getAutocompleteSearch(searchContext, input)
        commit('setShippingShippingRowsTitleOptions', response.list)
    },

    // DELETE Shipping rows
    deleteSelectedShippingShippingRows({ getters, commit }) {
        let id = getters.getSelectedShippingShippingRows[0] // only one id is passed
        let index = state.shippingShippingRows.findIndex(split => split.id == id)

        let numberOfRows = getters.getShippingShippingRows.length
        Vue.delete(state.shippingShippingRows, index)
        let newNumberOfRows = getters.getShippingShippingRows.length
        commit("setSelectedShippingShippingRows", [])

        if(numberOfRows > newNumberOfRows) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL') + '<br />' + i18n.t('lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON'),
                timeout: -1
            })
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_NOT_SUCCESSFUL'),
            })
        }

        commit('setSelectedShippingShippingRows', [])
        if(newNumberOfRows === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
    },  

    // Action: Create Invoice From Shipping document
    async createFromShipping({ getters, commit }) {  
        /*  check entry is connected to a returns note, if so inform the user
            they have to select the returns note, not the pick or shipping note */    
        let selectedShipping = getters.getSelectedShipping
        let shippingList = getters.getShipping                        
        let shippingData = shippingList.find(shipping => {
            return shipping.alvId === selectedShipping[0]
        })     
        
        if(shippingData.linkedShipping !== null) {
            if(shippingData.linkedShipping.type === "returning") {
                commit('setSnackbar', {
                    type: 'error',
                    msg: i18n.t('lang_ERP_SHIPPING_SNACKBAR_RETURNING_CONNECTED_CANT_CREATE_INVOICE'),
                    timeout: 10000
                })
                return 
            }
        } 
        let metaData = {}
        metaData["shippingIds"] = selectedShipping
        let queryParams = {
            "action" : "createInvoiceFromShipping"
        }

        let response = await api.triggerAction(DIR, metaData, queryParams)

        if(response.error === -1) {
            router.push( { name: 'InvoicesEdit', params: { alvId: response.response.alvId} })
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERIC_SNACKBAR_SAVING_SUCCESSFUL'),
            })
        } else {
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t(response.response.errorMsg),
            })
        }
    },

    // ACTION: Create Pro Forma invoice from Shipping document
    async createProForma({ getters, commit }) {
        // change in BE to use alvIds instead of idRec
        let metaData = {    "alvIds": getters.getSelectedShipping,
                            "amountToSplit": getters.getProFormaDialogDetailsAmountToSplit,
                            "proFormaText": getters.getProFormaDialogDetailsProFormaText,
                            "proFormaCurrency": getters.getSelectedCurrency,
                        }
        let queryParams = { "action": "createProForma" }
        let response = await api.triggerAction(DIR, metaData, queryParams)
        // console.log(response)
        if(response === 1 || response == undefined || response.error === 1) {
            commit('setSnackbar', {
                type: 'error',
                msg: this._vm.$alvPlugin.isLangConst(response.response.errorMsg) ? i18n.t(response.response.errorMsg) : response.response.errorMsg
            })            
        } else {
            api.getFileFromALV(response.response.path)
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL')
            })
        }    
    },

    // ACTION: Print Shipping document
    async printShipping({ getters, commit }) {
        let metaData = { "alvIds": getters.getSelectedShipping }
        let queryParams = { "action": "printPdf" }
        let response = await api.triggerAction(DIR, metaData, queryParams)
        if(response === 1 || response == undefined || response.error === 1) {
            commit('setSnackbar', {
                type: 'error',
                msg: this._vm.$alvPlugin.isLangConst(response.response.errorMsg) ? i18n.t(response.response.errorMsg) : response.response.errorMsg
            })            
        } else {
            api.getFileFromALV(response.response.path)
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL')
            })
        }    
    },

    // ACTION: Export shipping
    async exportShipping({ getters, commit }) {
        let queryParams = { "action" : "export" }
        let metaData = { "alvIds": getters.getSelectedShipping }

        let actionResponse = await api.triggerAction(DIR, metaData, queryParams)
        if(actionResponse.error === 1 || actionResponse === undefined) {
            let errorMsg = actionResponse.response.errorMsg
            commit('setSnackbar', {
                type: 'error',
                msg: this._vm.$alvPlugin.isLangConst(errorMsg) ? i18n.t(errorMsg) : errorMsg
            })
        } else {
            api.getFileFromALV(actionResponse.response.path)
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL')
            })
        }
    },

    // ACTION: create returns note
    async createReturnsFromShipping({ getters, commit}) {
        let shippingList = getters.getShipping
        let selectedShippingAlvId = getters.getSelectedShipping
        let shippingData = shippingList.find(shipping => {
            return shipping.alvId === selectedShippingAlvId[0]
        })

        if(shippingData.type === 'shipping' || shippingData.type === 'picking' || shippingData.type === 'incoming') {
            let queryParams = { "action" : "createReturnsFromShipping" }
            let metaData = { "alvIds": selectedShippingAlvId}

            let actionResponse = await api.triggerAction(DIR, metaData, queryParams) 
            if(actionResponse.error === 1 || actionResponse === undefined) {
                commit('setSnackbar', {
                    type: 'error',
                    msg: this._vm.$alvPlugin.isLangConst(errorMsg) ? i18n.t(errorMsg) : errorMsg
                })
            } else {
                router.push( { name: 'ShippingEdit', params: { alvId: actionResponse.response.alvId} })
                commit('setSnackbar', {
                    type: 'success',
                    msg: i18n.t('lang_GENERIC_SNACKBAR_SAVING_SUCCESSFUL'),
                })
            }
        } else {
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t('lang_ERP_SHIPPING_SNACKBAR_PLEASE_SELECT_SHIPPING_NOTE')
            })
        }
        
    }
}

export default {
    state, getters, actions, mutations
}